'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _prep = require('./internal/prep');

var _prep2 = _interopRequireDefault(_prep);

var _keyArray = require('./keyArray');

var _keyArray2 = _interopRequireDefault(_keyArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var keyed = function keyed() {
    return function (value) {
        return (0, _keyArray2.default)()(value).length;
    };
};

exports.default = (0, _prep2.default)({
    name: 'count',
    immutable: 'count',
    record: keyed,
    object: keyed,
    array: function array() {
        return function (value) {
            return value.length;
        };
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/count.js
// module id = 387
// module chunks = 35783957827783